module.exports = __webpack_public_path__ + "img/9.beb77a18.png";